import { render, staticRenderFns } from "./ExitStatus.vue?vue&type=template&id=24487b48&scoped=true"
import script from "./ExitStatus.vue?vue&type=script&lang=js"
export * from "./ExitStatus.vue?vue&type=script&lang=js"
import style0 from "./ExitStatus.vue?vue&type=style&index=0&id=24487b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24487b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSkeletonLoader})
